export const environment = {
  production: true,
  apikey:'AIzaSyAsv6YyCVteGu4LvpreebfdT8LWYltzUf4'
};
